import { render, staticRenderFns } from "./DimensionsSelector.vue?vue&type=template&id=d5d315ac&scoped=true"
import script from "./DimensionsSelector.vue?vue&type=script&lang=js"
export * from "./DimensionsSelector.vue?vue&type=script&lang=js"
import style0 from "./DimensionsSelector.vue?vue&type=style&index=0&id=d5d315ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5d315ac",
  null
  
)

export default component.exports